// src/PrivateRoute.jsx
import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import Cookies from "js-cookie";
import { tokenName } from "./constant";

export default function PrivateRoute() {
  const location = useLocation();

  // ✅ Redux flag (if your store sets it)
  const reduxAuthed = useSelector((s) => Boolean(s?.auth?.isAuthenticated));

  // ✅ Token from JS-cookie (transitional phase)
  const token = (() => {
    try {
      return Cookies.get(tokenName) || null;
    } catch {
      return null;
    }
  })();

  const isAuthed = reduxAuthed || Boolean(token);

  return isAuthed ? (
    <Outlet />
  ) : (
    <Navigate
      to="/sign-in"
      replace
      state={{ from: location }}
    />
  );
}
